import React from 'react'

const Cpapforsleep = () => {
  return (
    <div>
      <div className='bg:[#F3F4F8] lg:flex md:flex grid   '>
        <div className='  lg:w-1/2 md:w-1/2 w-2/2'>
            <div className='flex text-[22px] gap-2 '>
             <h3 className='text-[#1473AC] '>Home </h3>
             <h3 className=''>/Cpap Machines</h3>
            </div>
            <h3 className='lg:text-[36px] md:text-[36px] text-[20px] mt-5'>CPAP Machines for Sleep Apnea</h3>
             <p className='lg:text-[22px] md:text-[20px] text-[15px]'>Search all of our available machine types as well as machine accessories and replacement Parts below</p>
        </div>
   <img className="lg:w-[300px] md:w-[300px] lg:h-[300px] md:h-[300px] w-[200px] h-[200px] my-5  " src={require("../assets/Imagessix.png")} alt=""  />


      </div>
      <div></div>



    </div>
  )
}

export default Cpapforsleep
